import { ISystem, ISystemGroup } from '../types';

export const collectSystems = (group: ISystemGroup): ISystem[] => {
  if (!group.childGroups) return [];

  const systems: ISystem[] = [];
  const subGroups: ISystemGroup[] = [];

  for (const child of group.childGroups) {
    if ('address' in child) {
      systems.push(child);
    } else if ('childGroups' in child) {
      subGroups.push(child);
    }
  }

  return [...systems, ...subGroups.flatMap(collectSystems)];
};
